
import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import { setLoginPage, setUserRegisterDetails } from '../../General/Actions';
import Swal from 'sweetalert2';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Network from '../../Utils/network.js';
import blueBanner from '../../ImageAssets/blueBanner.png';

class ForgetPasswordComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            serviceId: "",
            siteKey: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        // Network.executeAxios("getRecaptchaSiteKey", "GET", "", (resp) => {
        //     this.state.siteKey = resp.SITEKEY
        //     this.setState({
        //         isLoading: false
        //     })
        // });
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({
            [name]: value
        })
    }

    loginButtonClicked = () => {
        this.props.setLoginPage("pageName", "login");
    }

    proceedBtnClicked() {
        if (ValidateForm.inputFieldMandatoryCheck("forgetPasswordContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("forgetPasswordContainer", this.props.locales, false)) {
                var currentService = {}
                this.setState({ isLoading: true })
                Network.executeAxios("fetchServiceInfoForPWL", "POST", { "serviceId": this.state.serviceId }, (fetchServiceInforesponse) => {
                    if (fetchServiceInforesponse && fetchServiceInforesponse.BillingSystem && fetchServiceInforesponse.BillingSystem.response &&
                        fetchServiceInforesponse.BillingSystem.response.dataset && fetchServiceInforesponse.BillingSystem.response.dataset.service_info) {
                        currentService = fetchServiceInforesponse.BillingSystem.response.dataset.service_info[0]
                    }
                   if(currentService && currentService.connection_type && currentService.connection_type === "2" && currentService.status === "1" ){
                        this.props.setUserRegisterDetails("serviceId",currentService.service_id);
                        this.props.setUserRegisterDetails("accountId",currentService.account_id);
                        var billingName = currentService.account_first_name + " " + currentService.account_last_name;
                        this.props.setUserRegisterDetails("billingName",billingName);
                        this.props.setLoginPage("pageName", "amountForRecharge")
                   } else {
                        Swal.fire("Please enter a valid prepaid number to continue")
                        this.setState({isLoading: false})
                   }
                    
                });
            }
        }
    }

    arrowIconClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        )
    }

    componentContent() {
        const forgetPasswordOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetPasswordOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-12 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", }}>
                            {this.rechargePartComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    rechargePartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                {/* <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                    <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                        <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                            <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.arrowIconClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                        </div>
                    </div>
                    <div className="col-md-12 row py-4 m-0 my-5 d-none d-sm-block">

                    </div>
                </div> */}
                <div className="col-md-12 p-0 m-0" style={{display:"flex",flex:1,flexDirection:"column"}}>
                    <div className='p-5' style={{  backgroundImage: `url(${blueBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%"}}>
                        <div className='pb-5' style={{}}>
                            <img alt="" src={ApuaWhiteTextLogo} />
                        </div>
                    </div>
                    <div className="col-md-12 row m-0 align-items-center justify-content-center">
                        <div className="col-md-4" id="forgetPasswordContainer">
                            <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.rechargeMMainHeadingInPhoneNumberPart}</div>
                            <div className="col-md-12" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.enterPhoneNumberFormatSubheadingInRecharge}</div>
                            <div className="col-md-12 p-0">
                                <div className="form-group col-md-12 pt-5" >
                                    <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.forgetPswPageUserNameTxt}</label>
                                    <Input maxLength={10} type="text" name="serviceId" autoComplete="new-password"
                                        style={{ color: '#404042', fontWeight: 500 }} className="loginCredItem pt-4 pb-3 input_data typeNumber mandatoryFieldSpecial"
                                        placeholder={this.props.locales.forgetPswPageUserNamePlc} 
                                        onChange={(event) => this.inputValueChange("serviceId", event.target.value)}
                                    />
                                    <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400 }}></div>
                                </div>
                                {/* <div className="col-md-12 pt-3 pb-4">
                                    <Reaptcha sitekey={this.props.siteKey.siteKey} onVerify={this.onVerify} />
                                </div> */}
                                <div className="d-flex col-md-12 pt-3 justify-content-center">
                                    <Button className="loginPageLoginButton align-items-center px-5" onClick={() => { this.proceedBtnClicked() }} disabled={this.state.serviceId === "" ? true : false}>
                                        Next
                                    </Button>
                                </div>
                                <div className="d-flex pt-4 col-md-12 justify-content-center">
                                    <div className='forgetLabel' onClick={() => { this.loginButtonClicked() }}>{this.props.locales.singInOptionTextInSignInWithOtpPart}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    loginPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 p-0 row m-0 pt-5 pb-5" style={{ backgroundColor: '#000000', opacity: 0.7, height: 'inherit', flex: 1 }}>
                <div className="col-md-1"></div>
                <div className="col-md-9 pl-5 pr-4 row pt-5 mt-5" style={{ flex: 1, alignItems: "center", justifyContent: "center", height: 'inherit' }}>
                    <div className="col-md-12 row pt-5" >
                        <div className="mb-1 col-md-12" style={{ fontSize: 32, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.forgetPswPageAlreadyHvAnAccTxt}</div>
                        <div className="mb-5 pb-4 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.forgetPswPageSignInHereTxt}</div>
                        <div className="col-md-12 pr-4">
                            <Button className="loginPageRegisterButton" style={{ fontSize: 24, fontWeight: 500 }} onClick={() => { this.loginButtonClicked() }}>
                                {this.props.locales.forgetPswPageSignInBtn}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        forgetPasswordDetails: state.forgetPasswordDetails,
        siteKey: state.siteKey
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const ForgetPasswordComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgetPasswordComponent)


export default ForgetPasswordComponentContainer;
